(function(a,b){var c=function(a,b,c){var d;return function e(){function g(){if(!c)a.apply(e,f);d=null}var e=this,f=arguments;if(d)clearTimeout(d);else if(c)a.apply(e,f);d=setTimeout(g,b||20)}};jQuery.fn[b]=function(a){return a?this.bind("resize",c(a)):this.trigger(b)}})(jQuery,"smartresize")

var $masonry = $('.masonry');
var navigationTopOffset;
var navigationHeight;

jQuery(window).load(function(){
  
  
  // 2026-09-18: #nav / nav.main were removed when the header was rebuilt as
  // #hr-header + #hr-nav. $('#nav').offset() is undefined on an empty set, so
  // .top threw a TypeError on every single page load and aborted the rest of
  // this handler. Guarded so it is a no-op when the legacy markup is absent.
  var $legacyNav = $('#nav');
  navigationTopOffset = $legacyNav.length ? $legacyNav.offset().top : 0;
  navigationHeight = $('nav.main').height() || 0;
  
  

  
  var IE6 = false /*@cc_on || @_jscript_version < 5.7 @*/;
  if(IE6){
    if($("#placeholder img").width() > 360){
      $("#placeholder img").css('width', '360px');
    } else {
      $("#placeholder img").css('width', $("#placeholder img").width()+'px'); // restrict to initial width of image
    }
  } else {
    $("#placeholder img").css('maxWidth', $("#placeholder img").width()+'px'); // restrict to initial width of image
  }

  var pw = $("#placeholder img").width() + 8;
  $("#placeholder img").parents('div.featured').css('maxWidth', pw+'px'); // force IE to play nice
  
});

jQuery(document).ready(function($){

  $("a.zoom").fancybox({
    padding:0,
    'titleShow': false,
    overlayColor: '#ffffff',
    overlayOpacity: 0.4
  });

  

  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });
  $('#product .thumbs a').click(function(){
    
    $('#zoom-image').attr('href', $(this).attr('href'));
    return false;
  });

  $('#product .add-to-cart').click(function(e){
    $('#add-item-to-cart').click();
  });

  

  
  // Same guard as above. Binding this handler without #nav meant every scroll
  // put .fixed-navigation and a bogus padding-top on <body>; the unguarded
  // .offset().top also threw here, so none of the handlers below this point
  // were ever bound (button blur, li.dropdown hover).
  var $stickyNav = $('#nav');
  if($stickyNav.length){
    navigationTopOffset = $stickyNav.offset().top;
    $(window).scroll(function(){
      navigationHeight = $('nav.main').height() || 0;
      navigationHeight += 20;
      if($(window).scrollTop() > navigationTopOffset){
        $('body').addClass('fixed-navigation');
        $('body').css('padding-top', navigationHeight + 'px');
      } else {
        $('body').removeClass('fixed-navigation');
        $('body').css('padding-top', '0');
      }
    });
  }
  

  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })

  $("li.dropdown").hover(function(){
    $(this).children('.dropdown').show();
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 1.0
    }, 200);
  }, function(){
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
    });
  });
}); // end document ready
